<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="personForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required placeholder="">
            <mat-option *ngFor="let type of propertyHelper.getPersonTypes()" [value]="type">
              {{ propertyHelper.getPersonTypeName(type) }}</mat-option
            >
          </mat-select>
          <mat-error>
            <span *ngIf="f('type').hasError('required')">Veuillez sélectionner un type</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Genre</mat-label>
          <mat-select formControlName="gender" required placeholder="">
            <mat-option *ngFor="let gender of propertyHelper.getPersonGenders()" [value]="gender">
              {{ propertyHelper.getPersonGenderName(gender) }}</mat-option
            >
          </mat-select>
          <mat-error>
            <span *ngIf="f('gender').hasError('required')">Veuillez sélectionner un genre</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Prénom</mat-label>
          <input matInput placeholder="" type="text" required formControlName="firstName" />
          <mat-error>
            <span *ngIf="f('firstName').hasError('required')">Veuillez saisir un prénom</span>
          </mat-error>
          <mat-error>
            <span *ngIf="f('firstName').hasError('maxlength')"
              >Le prénom ne doit dépasser 50 caractères</span
            >
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-md-6">
          <mat-label>Nom</mat-label>
          <input matInput placeholder="" type="text" required formControlName="name" />
          <mat-error>
            <span *ngIf="f('name').hasError('required')">Veuillez saisir un nom</span>
          </mat-error>
          <mat-error>
            <span *ngIf="f('name').hasError('maxlength')"
              >Le nom ne doit dépasser 50 caractères</span
            >
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Date de naissance</mat-label>
          <input
            *ngIf="isBrowserSupportsDateInput(); else birthDatePicker"
            matInput
            placeholder=""
            type="date"
            required
            formControlName="birthDate"
          />
          <ng-template #birthDatePicker>
            <input matInput [matDatepicker]="pickerBirth" required formControlName="birthDate" />
            <mat-datepicker-toggle matSuffix [for]="pickerBirth"></mat-datepicker-toggle>
            <mat-datepicker #pickerBirth></mat-datepicker>
          </ng-template>
          <mat-error>
            <span *ngIf="f('birthDate').hasError('required')">Veuillez saisir une date</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Lieu de naissance</mat-label>
          <input matInput placeholder="" type="text" formControlName="birthPlace" />
          <mat-error>
            <span *ngIf="f('name').hasError('maxlength')"
              >Le lieu ne doit dépasser 50 caractères</span
            >
          </mat-error>
        </mat-form-field>
      </div>
      <div class="text-center">
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          appTooltip="Valider"
          type="submit"
          [disabled]="formSubmitting"
        >
          Valider
        </button>
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          mat-dialog-close
          appTooltip="Annuler"
          (click)="onNoClick()"
        >
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
